'use client';

import { CaretDown, CaretUp } from '@drift-labs/icons';
import { cj } from 'src/utils/classNames';

export type SortDirection = 'ascending' | 'descending' | 'neutral';

export default function SortIcon({
	onClick,
	state,
	size,
	className,
}: {
	onClick?: () => void;
	state: SortDirection;
	size?: number;
	className?: string;
}) {
	const Icon = (() => {
		if (state === 'neutral') {
			return CaretDown;
		}

		if (state === 'descending') {
			return CaretDown;
		}

		return CaretUp;
	})();

	return (
		<span
			className={cj(
				'flex cursor-pointer flex-col items-center justify-center gap-y-2xs',
				state === 'neutral' ? 'text-tooltip-bg' : 'text-text-disabled',
				className
			)}
		>
			<Icon onClick={onClick} size={size} />
		</span>
	);
}
